<div class="task-panel-wrapper" [ngClass]="phase?.status?.id">
  <div class="header-full">
    <div class="header-text-wrapper">
      <div class="header-text">{{getType() === "content" ? 'Publish' : "phase?.name"}}</div>
      <div class="header-sub-text">{{getTasks()}}</div>
    </div>
    <div class="spacer"></div>

    <framework-action-dropdown
      *ngIf="getActions().length > 0"
      [actions]="getActions()"
      [location]="location"
      [task]="getTask()"
      [phase]="phase"
    ></framework-action-dropdown>
    <button styles-icon-button class="icon-button" (click)="expanded = !expanded">
      <mat-icon *ngIf="expanded">arrow_drop_down</mat-icon>
      <mat-icon *ngIf="!expanded">arrow_drop_up</mat-icon>
    </button>
  </div>

  <ng-container *ngIf="expanded" class="phase-body">
    <mat-divider></mat-divider>

    <div class="task-headers">
      <span class="task-headers-name">Task Name</span>
      <span class="task-headers-owner">Owner</span>
      <span class="task-headers-due-date">Due Date</span>
      <span class="task-headers-status">Status</span>
      <span class="task-headers-button"></span>
    </div>

    <ng-container *ngIf='getType() === "multi"'>
      <ng-container *ngFor="let version of phase?.children">
        <div class="version-divider" *ngIf="version.name !== 'Version 1'">
          <div class="version-divider-name">
            <span class="version-divider-name-text">{{version.name}}</span>
          </div>
          <mat-divider class="version-divider-line"></mat-divider>
        </div>
        <ng-container *ngFor="let task of version?.children">
          <content-task-row [task]="task" [phase]="phase" [location]="$any(location)"> </content-task-row>
        </ng-container>
      </ng-container>
    </ng-container>

    <ng-container *ngIf='getType() === "stage"'>
      <ng-container *ngFor="let task of phase?.children">
        <content-task-row [task]="task" [phase]="phase" [location]="$any(location)"> </content-task-row>
      </ng-container>
    </ng-container>

    <ng-container *ngIf='getType() === "content"'>
      <ng-container *ngFor="let task of phase?.children">
        <content-task-row [task]="task" [phase]="phase" [location]="$any(location)"> </content-task-row>
      </ng-container>
    </ng-container>

    <ng-container *ngIf='getType() === "task"'>
      <content-task-row [task]="phase" [phase]="phase" [location]="$any(location)"> </content-task-row>
    </ng-container>
    <!-- <div class="header-collapsed"></div> -->

    <ng-container *ngIf="projectHelper.showAssetSlider(phase?.assets)">
      <mat-divider class="asset-divider"></mat-divider>

      <framework-dialog-asset-slider
        [allAssets]="phase?.assets"
        [project]="phase | projectPipe"
        [phase]="phase"
        [thumbnailSize]="150"
      >
      </framework-dialog-asset-slider>
    </ng-container>
  </ng-container>
</div>
